export function getUserInfo(state) {
    return state.userInfo
}
export function getOrderInfo(state) {
    return state.orderInfo
}
export function getLabel(state) {
    return state.labelList
}
export function getHasQuickOrder(state) {
    return state.hasQuickOrder
}
export function getDispatchList(state) {
    return state.DispatchList
}
export function getIsLoggedIn(state) {
    return state.isLoggedIn
}

